export default __webpack_public_path__ + "static/media/sirclo_cloudxier1.3820782e.png";